module.exports = __webpack_public_path__ + "static/img/102755.6046e69e.png";